"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegionMenuSelectItem = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var flag_1 = require("../styled/flag");

var RegionMenuSelectItem = function RegionMenuSelectItem(_a) {
  var countryCode = _a.countryCode,
      name = _a.name,
      regionCode = _a.regionCode,
      props = tslib_1.__rest(_a, ["countryCode", "name", "regionCode"]);

  return react_1.default.createElement(ui_menu_1.MenuSelectItem, tslib_1.__assign({}, props, {
    "data-testid": "phone-field-region-option--".concat(regionCode),
    p: 1,
    label: react_1.default.createElement(ui_flex_1.Flex, {
      justifyContent: "space-between",
      alignItems: "center"
    }, react_1.default.createElement(ui_flex_1.Flex, {
      alignItems: "center"
    }, react_1.default.createElement(flag_1.Flag, {
      regionCode: regionCode,
      mr: 2
    }), " ", name), react_1.default.createElement(ui_text_1.Text, {
      pattern: "body",
      color: "grey-600"
    }, "+", countryCode))
  }));
};

exports.RegionMenuSelectItem = RegionMenuSelectItem;